import React from 'react';
import { Box, Typography } from '@mui/material';
import { GreenUpArrowIcon, DownArrow } from '../../../assets';

function RatingIndicator(props) {
    const { current, previous } = props;
    let ratingIcon='', ratingClass = '';
    const change = (previous === 0 && current ===0 ) ? 0 : (current - previous) * 100 / previous;
    const rating = Math.min(100, Math.abs(change).toFixed(0));

    if (previous === current) {
        // No Change
        ratingClass = 'gray-700';
        ratingIcon = <DownArrow color="#101828" rectcolor="#FFFFFF" />;
    } else if (change > 0) {
        // Change Increase
        ratingClass = 'success-700';
        ratingIcon = <GreenUpArrowIcon />;
    } else if (change < 0) {
        // Change Decrease
        ratingClass = 'error-700';
        ratingIcon = <DownArrow />;
    }
    return (
        <Box className="flex-row gap-4">
            {ratingIcon}
            <Typography className={`text-xs-medium ${ratingClass}`}>{rating || '0'}%</Typography>
        </Box>
    );
}

export default RatingIndicator;
